<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="填写记录"
      width="80%"
      @close="close"
    >
      <vab-query-form>
        <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              class="pr-10"
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="关键字搜索"
            />
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="x"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button
            icon="el-icon-download"
            type="primary"
            :loading="listLoading"
            @click="exportData"
          >
            导出
          </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
        <!-- <vab-query-form-right-panel :span="4">
          <el-button
            icon="el-icon-download"
            type="primary"
            :loading="listLoading"
            @click="exportData"
          >
            导出
          </el-button>
        </vab-query-form-right-panel> -->
      </vab-query-form>
      <el-table v-loading="listLoading" stripe :data="list">
        <el-table-column align="left" label="头像" show-overflow-tooltip>
          <template #default="{ row }">
            <el-avatar :src="row.people && row.people.avatar" :size="medium" />
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="姓名"
          prop="people.name"
          show-overflow-tooltip
        />
        <el-table-column align="left" label="性别" show-overflow-tooltip>
          <template #default="{ row }">
            <el-tag v-if="row.people && row.people.sex == 1" type="info">
              男
            </el-tag>
            <el-tag v-if="row.people && row.people.sex == 0" type="info">
              女
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column type="expand" label="结果" width="100px">
          <template #default="{ row }">
            <el-form label-position="left" class="demo-table-expand">
              <el-form-item
                v-for="(item, index) of row.basic.answerList"
                :key="index"
                :label="index + 1 + '.' + item.title"
              >
                <span v-if="!item.image" style="color: red">
                  {{ item.answer.join('、') }}
                </span>
                <el-image
                  v-if="item.image"
                  :src="item.answer[0]"
                  class="answer-image"
                  :preview-src-list="item.answer"
                ></el-image>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="创建日期"
          prop="created"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          fixed="right"
          label="操作"
          show-overflow-tooltip
          width="140px"
        >
          <template #default="{ row }">
            <el-button type="text" @click="editQuestion(row)">修改</el-button>
            <el-button type="text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
        <template #empty>
          <el-image
            class="vab-data-empty"
            :src="require('@/assets/empty_images/data_empty.png')"
          />
        </template>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.size"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
      <template #footer>
        <el-button @click="close">关 闭</el-button>
      </template>
    </el-dialog>
    <record-edit ref="RecordEdit" @fetch-data="fetchData"></record-edit>
  </div>
</template>

<script>
import moment from 'moment'
import {
  findRecordList,
  exportRecord,
  removeRecord,
} from '@/api/questionRegForm'
import RecordEdit from './recordEdit.vue'
export default {
  name: 'RecordList',
  components: { RecordEdit },
  data() {
    return {
      moment,
      dialogFormVisible: false,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        sheetId: '',
        keyword:'',
        date:null
      },
    }
  },
  created() {
    // this.fetchData()
  },
  methods: {
    editQuestion(row) {
      this.$refs.RecordEdit.showEdit(row)
    },
    handleDelete(row) {
      this.$baseConfirm(
        `你确定要删除：${row.people.name}的调查结果吗`,
        null,
        async () => {
          await removeRecord({ sheetRecordId: row.sheetRecordId })
          this.$baseMessage(
            `删除成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          this.queryData()
        }
      )
    },
    exportData() {
      this.listLoading = true
      exportRecord({
        sheetId: this.queryForm.sheetId,
      }).then((res) => {
        this.listLoading = false
        if (!res) return
        window.location.href = res.url
        this.$message.success('导出成功')
        this.close()
      })
    },
    showRecord(row) {
      this.queryForm.sheetId = row.sheetId
      this.fetchData()
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const queryForm = Object.assign({},this.queryForm)
      console.log(queryForm.date)
      if(queryForm.date) {
        queryForm.startTime = queryForm.date[0]
        queryForm.endTime = queryForm.date[1]
      }else {
        delete queryForm.startTime
        delete queryForm.endTime
      }
      delete queryForm.date
      const { list, total } = await findRecordList(queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.answer-image {
  height: 200px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
</style>
